import { Icon, SpaceBetween, TextContent } from '@amzn/awsui-components-react';
import { useTranslation } from 'react-i18next';

export function AmbassadorRegistrationHelp() {
  const { t } = useTranslation(['ambassadors', 'translation']);

  return (
    <div data-testid="ambassador-registration-help">
      <SpaceBetween size="m" direction="vertical">
        <div>
          <h3>{t('ambassadorRegistration.help.whoCanApply')}</h3>
          <ul>
            <li>{t('ambassadorRegistration.help.l4Employees')}</li>
            <li>{t('ambassadorRegistration.help.6MontTenure')}</li>
            <li>{t('ambassadorRegistration.help.managerApproval')}</li>
          </ul>
        </div>
        <div>
          <h3>{t('ambassadorRegistration.help.whatYoullDo')}</h3>
          <ul>
            <li>{t('ambassadorRegistration.help.organize')}</li>
            <li>{t('ambassadorRegistration.help.recruit')}</li>
            <li>{t('ambassadorRegistration.help.connect')}</li>
            <li>{t('ambassadorRegistration.help.promote')}</li>
            <li>{t('ambassadorRegistration.help.track')}</li>
          </ul>
        </div>
        <hr data-volunteer-center-hr />
        <div>
          <SpaceBetween size="m" direction="vertical">
            <SpaceBetween size="s" direction="horizontal">
              <h3 style={{ display: 'inline' }}>{t('ambassadorOffboarding.help.learnMore')}</h3>
              <Icon name="external" />
            </SpaceBetween>
            <TextContent>
              <SpaceBetween size="xxs" direction="vertical">
                <a
                  href="https://w.amazon.com/bin/view/AmazonInTheCommunity/Volunteering"
                  target="_blank"
                  rel="noreferrer"
                >
                  {t('ambassadorOffboarding.help.seeOurWiki')}
                </a>
                <a
                  href="https://w.amazon.com/bin/view/AmazonInTheCommunity/Volunteering/FAQs/"
                  target="_blank"
                  rel="noreferrer"
                >
                  {t('ambassadorOffboarding.help.readOurFAQs')}
                </a>
              </SpaceBetween>
            </TextContent>
          </SpaceBetween>
        </div>
      </SpaceBetween>
    </div>
  );
}
